export default __webpack_public_path__ + "static/media/69EB1E6E-5144-43BD-B8DD-7182E4719E4D_1_105_c.61c13c8d.jpeg";